(function () {
  const exchangeRate = 1.95583;

  function formatBGN(eur) {
    return (eur * exchangeRate)
      .toFixed(2)
      .replace('.', ',');
  }

  function extractNumber(text) {
    if (!text) return null;

    let cleaned = text
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, '')
      .replace(',', '.');

    const match = cleaned.match(/\d+(\.\d+)?/);
    return match ? parseFloat(match[0]) : null;
  }

  function addBGNPrice(el) {
    if (!el) return;

    if (el.querySelector('.bgn-price')) return;

    const rawText = el.innerText || el.textContent || '';

    if (/лв/i.test(rawText)) return;

    if (!/€|EUR/i.test(rawText)) return;

    const priceEUR = extractNumber(rawText);
    if (!priceEUR) return;

    const formattedBGN = formatBGN(priceEUR);

    const bgnSpan = document.createElement('span');
    bgnSpan.className = 'bgn-price';
    bgnSpan.style.marginLeft = '8px';
    bgnSpan.textContent = ` | ${formattedBGN} лв.`;

    el.appendChild(bgnSpan);
  }

  const priceSelectors = [
    'span.price',
    '.price-item',
    '.price-item--regular',
    '.price-item--sale',
    '.price-item--last',
    '.variant-item__details .price',
    '.product-price',
    '.product-option',
    'p.totals__total-value',
    '[class*="price"]'
  ];

  const processedElements = new Set();

  function processPrices(root = document) {
    priceSelectors.forEach(selector => {
      root.querySelectorAll(selector).forEach(el => {
        if (processedElements.has(el)) return;
        processedElements.add(el);
        addBGNPrice(el);
      });
    });
  }

  processPrices();

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          processPrices(node);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();